/* 
Хук для возврата назад, с умными проверками
*/

// - Четкое ограничение на 5 попыток
// - Интервал между попытками 100 мс (можно регулировать)
// - Гарантированный фолбек после 5 неудач
// - Защита от утечек памяти через очистку таймеров
// - Корректная работа при быстром клике "назад"

import { useRouter } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';

export function useSmartBack(fallbackPath = '/') {
  const router = useRouter();
  const [isNavigating, setIsNavigating] = useState(false);
  const timeoutRef = useRef();
  const attemptsRef = useRef(0);
  const initialUrlRef = useRef('');

  const smartBack = useCallback(() => {
    if (isNavigating) return;

    setIsNavigating(true);
    attemptsRef.current = 0;
    initialUrlRef.current = window.location.href;

    const checkAndRetry = () => {
      if (window.location.href === initialUrlRef.current) {
        attemptsRef.current += 1;

        if (attemptsRef.current <= 5) {
          router.back();
          timeoutRef.current = setTimeout(checkAndRetry, 100);
        } else {
          router.replace(fallbackPath);
          setIsNavigating(false);
        }
      } else {
        setIsNavigating(false);
      }
    };

    router.back();
    timeoutRef.current = setTimeout(checkAndRetry, 100);
  }, [isNavigating, router, fallbackPath]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { smartBack, isNavigating };
}
